import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class FuelPriceRangeService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('FuelPriceRange');
	}
	
	loadAll() : Observable<TooBig4Car.Logic.FuelPriceRange[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForCustomer(id: System.Guid): Observable<TooBig4Car.Logic.FuelPriceRange[]> {
		return this.myBaseService.loadAll(this.url + '/ForCustomer/' + (id ?? this.myBaseService.configData.DefaultEmptyGuid));
	}
	save(tempItem: TooBig4Car.Logic.FuelPriceRange) : Observable<TooBig4Car.Logic.FuelPriceRange> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.FuelPriceRange> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.FuelPriceRange>{
		return this.myBaseService.get(id, this.url);
	}
}
